exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.required[data-v-65dfe134] {\n\tcolor: red;\n}\n", ""]);

// exports
